const errorDetails = new Map([
  [
    '403',
    {
      header: 'Forbidden',
      text: 'You don’t have permission to access this page',
      CTADetails: {
        onClick: () => window?.location.replace(`${window?.location.origin}/`),
        text: 'Go to the homepage',
      },
      suggestion: 'Your admin may be able to change your permissions.',
      suggestion2: 'Otherwise, try navigating back to the',
    },
  ],
  [
    '404',
    {
      header: 'Not Found',
      text: 'The page you are trying to open cannot be found',
      CTADetails: {
        onClick: () => window?.location.replace(`${window?.location.origin}/`),
        text: 'Go to the homepage',
      },
      suggestion: 'The URL may no longer exist, or it could have a typo.',
      suggestion2: 'Try navigating to it again, or go to the',
    },
  ],
  [
    '500',
    {
      header: 'Oops',
      text: 'Something went wrong and the app needs to restart',
      CTADetails: {
        onClick: () => window?.location.reload(),
        text: 'Reload the app',
      },
      suggestion: 'Reloading the page can often fix the problem.',
      suggestion2: 'Otherwise, try navigating back to the',
    },
  ],
]);

export default errorDetails;
